import React, { useState } from "react";
import { Row } from "antd";
import { StateContext } from "./State";
import Welcome from "./Welcome";
import Form from "./Form";
import Finish from "./Finish";

const Index = (props) => {
  const [state, setState] = useState(props);
  const { step } = state;

  const updateState = (newState) => {
    setState((state) => ({ ...state, ...newState }));
  };

  return (
    <Row justify="center">
      <div className="consultation-scheduling__container">
        <StateContext.Provider value={{ state, updateState }}>
          {step === "welcome" && <Welcome />}
          {step === "form" && <Form />}
          {step === "finish" && <Finish />}
        </StateContext.Provider>
      </div>
    </Row>
  );
};

export default Index;
